import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Alert, AlertDescription } from '../ui/alert';
import { CheckCircle2, AlertTriangle } from 'lucide-react';

const CompleteStep = ({ importResult, onImportMore }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 animate-fade-in">
      <Card className="rounded-2xl border-[#E0D6C8]">
        <CardContent className="py-12 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-emerald-100 rounded-full flex items-center justify-center">
            <CheckCircle2 className="w-8 h-8 text-emerald-600" />
          </div>
          <h2 className="text-2xl font-bold text-[#1A1A1A] font-['Manrope'] mb-2">Import Complete!</h2>
          <p className="text-[#5A5A5A] mb-6">
            Successfully imported {importResult.imported} of {importResult.total} resources
          </p>
          
          {importResult.errors.length > 0 && (
            <Alert className="mb-6 bg-amber-50 border-amber-200 text-left">
              <AlertTriangle className="w-4 h-4 text-amber-600" />
              <AlertDescription className="text-amber-800">
                {importResult.errors.length} resources could not be imported due to missing required fields.
              </AlertDescription>
            </Alert>
          )}
          
          <div className="flex gap-3 justify-center">
            <Button variant="outline" onClick={onImportMore} className="rounded-full">Import More</Button>
            <Button onClick={() => navigate('/')} data-testid="view-resources-btn" className="bg-[#5C4023] hover:bg-[#4A331C] rounded-full">
              View Resources
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompleteStep;
